import {apiCall} from 'library';

export function removeAllStocks() {
    return apiCall('/api/mgmt/remove_stocks', 
        {method: 'POST'}
    );
}